export default "https://cdn-static.gokick.com/assets/abc7ffeff8198bd9a29b582a19941a8ba3b1c5b9/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";